module.exports = __webpack_public_path__ + "img/sonac.8f6c247c.jpg";